import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompany: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});
